// Schedule.ts
import { IResponsePassed } from '../Models/ResponseModel';
import { postJson, getJson, getObject, deleteJson } from '../ChoiceApi';
import { IPatientMultipleCheckInInputs, ICheckInOutDashboardSearchInputs, ICheckInOutDashboardListItem, ICheckInOutDashboardFilterItem, CheckInOutDashboardTab,
         IQuickPayTabList, ICheckInOutDashboardUpdateStatusInputs, ICheckInOutDashboardUpdateStatusResult, ICheckInOutDashboardAppointmentStatusItem,
         ICheckInOutDashboardFilterSaveInputs, ICheckInOutDashboardFilterSaveResponse, ICheckInOutFilterAppointmentTypeItem, ICheckInOutFilterTypeResult,
         ICheckInOutDashboardPassedOnlyResult, ICheckInOutDashboardTabResult, ICheckInOutDashboardTabSaveInputs, ICheckInOutDashboardStatusWorkflowSaveInputs,
         ISchedulePatientMultipleCheckInExists, IPatientMultipleCheckInResults } from '../Models/ScheduleModel';
import { IInsuranceProfileResults, IInsuranceProfileParams, IProviderSearchInputs, IProviderListItem, IAppointmentRequest, IAppointmentSaveResult,
         IAppointmentTypeItem } from '../Models/Schedule/Schedule';
import { DatabaseIdTypes } from '../../Enums/ChoiceEnums';
import { NoTzDate } from '../DateUtils';

export async function PatientMultipleCheckInSave(payload: IPatientMultipleCheckInInputs): Promise<IResponsePassed> {
    return (await postJson("api/Schedule/PatientMultipleCheckInSave", payload)) as IResponsePassed;
}

export async function statusOptions(): Promise<IStatusOptionModel[]> {
    return (await getJson("api/Schedule/StatusOptions")) as IStatusOptionModel[]
}

export async function getPatientAppointmentInfo(idAppointment: number, idTypePatient: DatabaseIdTypes, idPatient: number): Promise<PatientAppointmentInfo | undefined> {
    return await getObject(`api/Schedule/Appointment/Patient/${idAppointment}/${idTypePatient}/${idPatient}`);    
}

export async function DashboardSearch(payload: ICheckInOutDashboardSearchInputs): Promise<ICheckInOutDashboardListItem[]> {
    return (await postJson("api/Schedule/CheckInOutDashboard/Search", payload)) as ICheckInOutDashboardListItem[];
}

export async function DashboardFilterList(tabId: CheckInOutDashboardTab): Promise<ICheckInOutDashboardFilterItem[]> {
    return (await getJson(`api/Schedule/CheckInOutDashboard/FilterList/${tabId}`)) as ICheckInOutDashboardFilterItem[]
}

export async function DashboardStatusList(tabId: CheckInOutDashboardTab): Promise<ICheckInOutDashboardAppointmentStatusItem[]> {
    return (await getJson(`api/Schedule/CheckInOutDashboard/StatusList/${tabId}`)) as ICheckInOutDashboardAppointmentStatusItem[]
}

export async function QuickPayTabList(tabId: number): Promise<IQuickPayTabList> {
    return (await getJson(`api/Schedule/CheckInOutDashboard/QuickPay/TabList/${tabId}`)) as IQuickPayTabList
}
export async function QuickPayTabListDefault(tabId: number): Promise<IQuickPayTabList> {
    return (await getJson(`api/Schedule/CheckInOutDashboard/QuickPay/TabListDefault/${tabId}`)) as IQuickPayTabList
}

export async function DashboardUpdateStatus(payload: ICheckInOutDashboardUpdateStatusInputs): Promise<ICheckInOutDashboardUpdateStatusResult> {
    return (await postJson("api/Schedule/CheckInOutDashboard/UpdateStatus", payload)) as ICheckInOutDashboardUpdateStatusResult;
}

export async function DashboardFilterSave(payload: ICheckInOutDashboardFilterSaveInputs): Promise<ICheckInOutDashboardFilterSaveResponse> {
    return (await postJson("api/Schedule/CheckInOutDashboard/FilterSave", payload)) as ICheckInOutDashboardFilterSaveResponse;
}

export async function DashboardAppointmentTypeList(filterId: number): Promise<ICheckInOutFilterAppointmentTypeItem[]> {
    return (await getJson(`api/Schedule/CheckInOutDashboard/AppointmentTypeList/${filterId}`)) as ICheckInOutFilterAppointmentTypeItem[]
}

export async function DashboardTypeList(filterId: number): Promise<ICheckInOutFilterTypeResult> {
    return (await getJson(`api/Schedule/CheckInOutDashboard/TypeList/${filterId}`)) as ICheckInOutFilterTypeResult
}

export async function DashboardDeleteFilter(filterId: number): Promise<ICheckInOutDashboardPassedOnlyResult> {
    return (await deleteJson(`api/Schedule/CheckInOutDashboard/Delete/${filterId}`)) as ICheckInOutDashboardPassedOnlyResult
}

export async function DashboardTab(tabId: number): Promise<ICheckInOutDashboardTabResult> {
    return (await getJson(`api/Schedule/CheckInOutDashboard/Tab/${tabId}`)) as ICheckInOutDashboardTabResult
}

export async function DashboardTabSave(payload: ICheckInOutDashboardTabSaveInputs): Promise<ICheckInOutDashboardPassedOnlyResult> {
    return (await postJson("api/Schedule/CheckInOutDashboard/TabSave", payload)) as ICheckInOutDashboardPassedOnlyResult;
}

export async function DashboardStatusWorkflowSave(payload: ICheckInOutDashboardStatusWorkflowSaveInputs): Promise<ICheckInOutDashboardPassedOnlyResult> {
    return (await postJson("api/Schedule/CheckInOutDashboard/StatusWorkflowSave", payload)) as ICheckInOutDashboardPassedOnlyResult;
}

export async function PatientMultipleCheckInExists(appointmentId?: number): Promise<ISchedulePatientMultipleCheckInExists|undefined> {
    return await getObject(`api/Schedule/PatientMutltipleCheckInExists/${appointmentId}`);
}

export async function PatientMultipleCheckInList(appointmentId?: number): Promise<IPatientMultipleCheckInResults|undefined> {
    return await getObject(`api/Schedule/PatientMultipleCheckInList/${appointmentId}`);
}

export async function InsuranceProfileInfo(payload: IInsuranceProfileParams): Promise<IInsuranceProfileResults> {
    return (await postJson(`api/Schedule/InsuranceProfile`, payload)) as IInsuranceProfileResults;
}

export async function ReferringProviderList(payload: IProviderSearchInputs): Promise<IProviderListItem[]> {
    return (await postJson(`api/Provider/SearchAll`, payload)) as IProviderListItem[];
}

export async function CreateAppointment(payload: IAppointmentRequest): Promise<IAppointmentSaveResult> {
    return (await postJson(`api/Schedule/CreateAppointment`, payload)) as IAppointmentSaveResult;
}

export async function ResourceAppointmentTypeList(resourceId?: number): Promise<IAppointmentTypeItem[] | undefined> {
    return await getObject(`api/Schedule/ResourceAppointmentTypeList/${resourceId}`);
}

export function GetCurrentDate() {
    const date = new Date();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;    
}

export interface IStatusOptionModel {
    appointment_status_id: number,
    appointment_status_description: string,
    color_id: number,
    isActive: boolean
}


export interface PatientAppointmentInfo {
    appointmentId: number,
    patientId?: number,
    entityId?: number,

    startDateTime?: NoTzDate,
    endtDateTime?: NoTzDate,
    isTelemedicineAppointment?: boolean
}